var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "w-100pct h-60px bg-cl-black cl-white f-s-18px f-w-bold pd-18px"
      },
      [
        _c(
          "router-link",
          { attrs: { to: { name: "UserInfo" } } },
          [
            _c("svg-filler", {
              staticClass: "mg-r-auto f-left cs-pointer",
              attrs: {
                path: "/static/svg/back.svg",
                fill: "#ffffff",
                width: "20px",
                height: "20px"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("span", [_vm._v("\n      รายงานสรุปยอดประจำวัน\n    ")])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "columns is-centered is-marginless" }, [
      _c(
        "div",
        { staticClass: "h-60calc mg-t-16px pd-hrzt-35px column is-4" },
        [
          _c("div", { staticClass: "dp-flex jtf-ct-space-between " }, [
            _c("div", { staticClass: "f-left f-s-14px f-w-bold" }, [
              _vm._v("เลือกวันที่")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "f-right w-62pct" },
              [
                _c("b-datepicker", {
                  attrs: {
                    placeholder: "เลือกวันที่ ที่ต้องการพิมพ์",
                    icon: "calendar-today",
                    "max-date": _vm.maxDate
                  },
                  model: {
                    value: _vm.selectedDate,
                    callback: function($$v) {
                      _vm.selectedDate = $$v
                    },
                    expression: "selectedDate"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dp-flex jtf-ct-space-between mg-t-16px" }, [
            _c("div", { staticClass: "f-left f-s-14px f-w-bold" }, [
              _vm._v("เงินตั้งต้น")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "f-right w-62pct" },
              [
                _c("b-input", {
                  attrs: { type: "number", min: "0" },
                  model: {
                    value: _vm.startPrice,
                    callback: function($$v) {
                      _vm.startPrice = $$v
                    },
                    expression: "startPrice"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dp-flex jtf-ct-space-between mg-t-16px" }, [
            _c("div", { staticClass: "f-left f-s-14px f-w-bold" }, [
              _vm._v("ยอดงานนำส่ง")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "f-right w-62pct" },
              [
                _c("b-input", {
                  attrs: { type: "number", min: "0" },
                  model: {
                    value: _vm.givePrice,
                    callback: function($$v) {
                      _vm.givePrice = $$v
                    },
                    expression: "givePrice"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dp-flex jtf-ct-space-between mg-t-16px" }, [
            _c("div", { staticClass: "f-left f-s-14px f-w-bold" }, [
              _vm._v("เครื่องปริ้น")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "f-right w-62pct" },
              [
                _c(
                  "b-select",
                  {
                    attrs: { expanded: "", placeholder: "เลือก Printer" },
                    model: {
                      value: _vm.selectedPrinter,
                      callback: function($$v) {
                        _vm.selectedPrinter = $$v
                      },
                      expression: "selectedPrinter"
                    }
                  },
                  _vm._l(_vm.printers, function(printer, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: printer.ip } },
                      [_vm._v(_vm._s(printer.name))]
                    )
                  })
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns is-marginless" }, [
            _vm.startPrice === "" ||
            _vm.startPrice === "0" ||
            (_vm.givePrice === "" || _vm.givePrice === "0") ||
            _vm.selectedPrinter === ""
              ? _c(
                  "div",
                  {
                    staticClass:
                      "disabled mg-auto pd-vtc-5px pd-hrzt-2px mg-t-16px"
                  },
                  [_vm._v(" พิมพ์รายงาน ")]
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "print-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px mg-t-16px",
                    on: {
                      click: function($event) {
                        _vm.print()
                      }
                    }
                  },
                  [_vm._v(" พิมพ์รายงาน ")]
                )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31616276", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31616276","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/ReportZ.vue
// module id = 508
// module chunks = 1